import React, { useEffect, useState } from 'react';
import { Container, DateRangeWrapper, Wrapper, Row, DateInput, DateTitle, SaveButton } from './styled';
import  DatePicker  from 'react-datepicker';
import { pt } from 'date-fns/locale';
import Button from '../../ReUsableComponents/Button';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { dateRevisao1DatesUpdate} from '../../../../../Services/cardService';

const DataRevisao1Popover = (props) => {
	const dispatch = useDispatch();
	const card = useSelector((state) => state.card);
	
	const [dateRevisao1, setdateRevisao1] = useState(
		card.dateRevisao1 ? moment(card.dateRevisao1).toDate():null
	);

	useEffect(() => {
		// Atualiza o estado quando o card.dateEntrega mudar
		if (card.dateRevisao1) {
			setdateRevisao1(moment(card.dateRevisao1).toDate());
		}
	}, [card.dateRevisao1]);

	const handleSaveClick = async () => {
		props.closeCallback();
		await dateRevisao1DatesUpdate(
			card.cardId,
			card.listId,
			card.boardId,
			dateRevisao1 ? moment(dateRevisao1).format('YYYY-MM-DD') : null,
			dispatch
		);
	};

	const handleRemoveClick = async () => {
		props.closeCallback();
		await dateRevisao1DatesUpdate(card.cardId, card.listId, card.boardId, null, dispatch);
	};


	return (
		<Container>
			<DateRangeWrapper>
				<DatePicker
					selected={dateRevisao1}
					onChange={(date) => setdateRevisao1(date)}
					dateFormat="dd/MM/yyyy"
					locale={pt}					
					placeholderText="Selecione uma data"
					inline // Mantém o calendário visível				
				/>
			</DateRangeWrapper>
			<Wrapper>
				<DateTitle>Data de Entrega</DateTitle>
				<Row>					
					<DateInput						
						value={dateRevisao1 ? moment(dateRevisao1).format('DD/MM/YYYY') : ''}						
					/>
				</Row>
				<SaveButton onClick={handleSaveClick}>Salvar</SaveButton>
				<Button clickCallback={handleRemoveClick} title="Remover" />
			</Wrapper>
		</Container>
	);
};

export default DataRevisao1Popover;
